function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "20",
  fill: "none"
}, props), React.createElement("path", {
  fill: "url(#svg3293742969__paint0_linear)",
  d: "M7.953 1.529C7.284.662 6.513.112 5.59.003c-.11.002-.221.01-.33.028C1.912.561.085 5.281 0 10.001c.085 4.72 1.912 9.44 5.26 9.97.11.018.22.026.33.029.924-.11 1.694-.66 2.363-1.526C6.199 16.537 5.35 13.116 5.293 10c.056-3.114.905-6.535 2.66-8.472z"
}), React.createElement("path", {
  fill: "url(#svg3293742969__paint1_linear)",
  d: "M22.656.03a2.47 2.47 0 00-.33-.029h-.064a21414.065 21414.065 0 01-5.136 0 3.993 3.993 0 011.719.583c.407.25.78.57 1.119.944 1.754 1.936 2.603 5.358 2.66 8.472-.057 3.114-.906 6.536-2.66 8.473a5.176 5.176 0 01-1.12.943 3.987 3.987 0 01-1.718.582l.08.002a20997.24 20997.24 0 015.12-.001c.11-.003.221-.011.33-.029 3.348-.53 5.175-5.25 5.26-9.97-.085-4.72-1.912-9.44-5.26-9.97z"
}), React.createElement("path", {
  fill: "url(#svg3293742969__paint2_linear)",
  d: "M15.56 17.102c-.239.511-.484.968-.737 1.377a.186.186 0 00.016.218c.563.66 1.2 1.11 1.937 1.262.115.023.233.036.35.04a3.989 3.989 0 001.72-.582c.407-.25.78-.57 1.118-.944-1.043-1.352-1.84-3.474-2.589-5.887a.093.093 0 00-.178 0c-.48 1.598-1.002 3.163-1.636 4.516z"
}), React.createElement("path", {
  fill: "url(#svg3293742969__paint3_linear)",
  d: "M7.953 1.528C8.997 2.88 9.793 5 10.543 7.415c.026.087.15.087.177 0 .48-1.599 1.002-3.164 1.637-4.517.24-.51.484-.968.738-1.377a.185.185 0 00-.017-.218c-.562-.66-1.2-1.11-1.936-1.261A2.092 2.092 0 0010.71 0H5.653L5.59.001c.924.11 1.694.66 2.363 1.527z"
}), React.createElement("path", {
  fill: "url(#svg3293742969__paint4_linear)",
  d: "M18.845.584a3.988 3.988 0 00-1.719-.582 2.05 2.05 0 00-.35.04c-2.823.58-4.19 5.54-5.467 9.958-.995 3.443-1.952 6.654-3.356 8.473-.669.866-1.44 1.417-2.363 1.526h.064a20997.197 20997.197 0 015.136 0 2.06 2.06 0 00.352-.04c2.822-.58 4.189-5.542 5.466-9.96.995-3.442 1.952-6.653 3.356-8.472a5.173 5.173 0 00-1.119-.943z"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg3293742969__paint0_linear",
  x1: "3.976",
  x2: "3.976",
  y1: "-.05",
  y2: "20.011",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF7BFF"
}), React.createElement("stop", {
  offset: ".072",
  stopColor: "#F46BFF"
}), React.createElement("stop", {
  offset: ".266",
  stopColor: "#D945FF"
}), React.createElement("stop", {
  offset: ".458",
  stopColor: "#C527FF"
}), React.createElement("stop", {
  offset: ".646",
  stopColor: "#B611FF"
}), React.createElement("stop", {
  offset: ".829",
  stopColor: "#AD04FF"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#A0F"
})), React.createElement("linearGradient", {
  id: "svg3293742969__paint1_linear",
  x1: "22.523",
  x2: "22.523",
  y1: "-.001",
  y2: "20.056",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF7BFF"
}), React.createElement("stop", {
  offset: ".072",
  stopColor: "#F46BFF"
}), React.createElement("stop", {
  offset: ".266",
  stopColor: "#D945FF"
}), React.createElement("stop", {
  offset: ".458",
  stopColor: "#C527FF"
}), React.createElement("stop", {
  offset: ".646",
  stopColor: "#B611FF"
}), React.createElement("stop", {
  offset: ".829",
  stopColor: "#AD04FF"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#A0F"
})), React.createElement("linearGradient", {
  id: "svg3293742969__paint2_linear",
  x1: "17.378",
  x2: "17.378",
  y1: "19.919",
  y2: ".012",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF7BFF"
}), React.createElement("stop", {
  offset: ".072",
  stopColor: "#F46BFF"
}), React.createElement("stop", {
  offset: ".266",
  stopColor: "#D945FF"
}), React.createElement("stop", {
  offset: ".458",
  stopColor: "#C527FF"
}), React.createElement("stop", {
  offset: ".646",
  stopColor: "#B611FF"
}), React.createElement("stop", {
  offset: ".829",
  stopColor: "#AD04FF"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#A0F"
})), React.createElement("linearGradient", {
  id: "svg3293742969__paint3_linear",
  x1: "9.354",
  x2: "9.354",
  y1: "19.988",
  y2: "-.011",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF7BFF"
}), React.createElement("stop", {
  offset: ".072",
  stopColor: "#F46BFF"
}), React.createElement("stop", {
  offset: ".266",
  stopColor: "#D945FF"
}), React.createElement("stop", {
  offset: ".458",
  stopColor: "#C527FF"
}), React.createElement("stop", {
  offset: ".646",
  stopColor: "#B611FF"
}), React.createElement("stop", {
  offset: ".829",
  stopColor: "#AD04FF"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#A0F"
})), React.createElement("linearGradient", {
  id: "svg3293742969__paint4_linear",
  x1: "12.776",
  x2: "12.776",
  y1: "20.003",
  y2: "-.018",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF7BFF"
}), React.createElement("stop", {
  offset: ".072",
  stopColor: "#F46BFF"
}), React.createElement("stop", {
  offset: ".266",
  stopColor: "#D945FF"
}), React.createElement("stop", {
  offset: ".458",
  stopColor: "#C527FF"
}), React.createElement("stop", {
  offset: ".646",
  stopColor: "#B611FF"
}), React.createElement("stop", {
  offset: ".829",
  stopColor: "#AD04FF"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#A0F"
})))));